<template>
  <NotMobile__WP_Alert />
  <div v-if="loaded" class="ma-2">
    <div v-if="selected.length > 0">
      <v-row>
        <v-col cols="2">
          <C_Reg :tickets="t_r"/>
        </v-col>
        <v-col>
          <C_InWork :tickets="t_w"/>
        </v-col>
        <v-col cols="3" style="position: relative">
          <C_Widgets />
        </v-col>
      </v-row>
    </div>
    <div v-else class="d-flex align-center justify-center" style="height: 100vh">
      <v-card flat rounded="xl" :color="`#f6f6f6`">
        <template v-slot:title>
          <div class="d-flex">
            <span class="font-weight-bold">ВЫБЕРИТЕ УЧАСТОК</span>
            <v-spacer />
            <v-btn variant="text" v-if="tmp_filters.length > 0" v-on:click="tmp_filters = []" density="comfortable" :icon="['fas', 'trash']">
              <v-icon :icon="['fas', 'trash']" />
            </v-btn>
          </div>
        </template>
        <template v-slot:text>
          <v-switch
              v-for="filter in districts"
              color="light-green"
              density="compact"
              :key="filter"
              :label="filter.name"
              :value="filter.guid"
              v-model="tmp_filters" />
        </template>
        <template v-slot:actions>
          <v-btn rounded="xl" block :color="tmp_filters.length > 0 ? 'light-green' : 'grey-darken-1'" v-on:click="tmp_filters.length > 0 ? append_filters() : null" :disabled="!tmp_filters.length > 0">ПЕРЕЙТИ В ПАНЕЛЬ</v-btn>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { ErrorStore } from "@/store/ErrorStore";
import {FiltersSelStore, FiltersStore, TicketsStore, UpdateTimeStore} from "@/store/Dashboard/TVApp";
import C_Widgets from "@/components/Dashboard/Columns/C_Widgets.vue";
import C_InWork from "@/components/Dashboard/Columns/C_InWork.vue";
import C_Reg from "@/components/Dashboard/Columns/C_Reg.vue";
import route_check from "@/libs/route_check";
import NotMobile__WP_Alert from "@/components/wp_planner/alerts/not_mobile.alert.vue";
import {DistrictsList} from "@/store/global/districts.dictionary";

export default {
  name: "TV-App",
  components: {NotMobile__WP_Alert, C_Reg, C_InWork, C_Widgets},

  async beforeMount() {
    route_check('/dashboard/tv').then(async res => {
      if (res) {
        await this.loadFromOneC_list()
        //this.regionList()
        this.timer = setInterval(async () => {
          await this.loadFromOneC_list()
        }, 1000 * 60)
        this.selected = []
      } else {
        this.$router.push({ name: 'home' })
      }
    })
  },
  beforeRouteLeave() {
    console.log('Выключаю автообновление')
    clearInterval(this.timer)
  },
  data() {
    return {
      timer: null,
      loaded: false,
      tmp_filters: [],
      t_r: {
        status: false,
        list: []
      },
      t_w: {
        status: false,
        list: []
      },
    }
  },
  watch: {
    selected (newFilter) {
      console.log('ИЗМЕНЕН ФИЛЬТР: ' + newFilter)
      this.sortTickets()
    }
  },
  computed: {
    tickets_filtered() {
      return this.tickets.filter(ticket => this.selected.includes(ticket['УчастокGUID']))
    },
    districts() {
      return DistrictsList().get()
    },
    errors: {
      get() {
        return ErrorStore().get()
      },
      set(value) {
        ErrorStore().set(value)
      }
    },
    update_time: {
      get() {
        return UpdateTimeStore().get()
      },
      set(value) {
        UpdateTimeStore().set(value)
      }
    },
    tickets: {
      get() {
        return TicketsStore().get()
      },
      set(value) {
        TicketsStore().set(value)
      }
    },
    filters: {
      get() {
        return FiltersStore().get()
      },
      set(value) {
        FiltersStore().set(value)
      }
    },
    selected: {
      get() {
        return FiltersSelStore().get()
      },
      set(value) {
        FiltersSelStore().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  },
  methods: {
    append_filters: function () {
      this.selected = this.tmp_filters
    },
    loadFromOneC_list: async function () {
      this.errors = []
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetTVTickets`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }
      console.log('Получаю список обращений...')
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            console.log('Успешно!')
            this.loaded = true
            this.tickets = JSON.parse(result)
            this.sortTickets()
            this.update_time = new Date()
          }).catch((err) => {
            this.errors.push({type: 'one_error', error: 'Ошибка получения списка обращений...'})
            console.log('Ошибка получения данных...')
            console.warn(err)
          })
    },
    regionList: async function () {
      this.filters = []

      for (let ticket of this.tickets) {
        let status = false
        for (let tmp of this.filters) {
          if (tmp.name === ticket['Участок']) {
            status = true
          }
        }
        if (!status) {
          this.filters.push({
            name: ticket['Участок'],
            guid: ticket['УчастокGUID']
          })
        }
      }
    },
    sortTickets: function () {
      this.t_r.list = []
      this.t_r.status = false
      this.t_w.list = []
      this.t_w.status = false
      for (let ticket of this.tickets_filtered) {
        if (ticket['СтатусПредставление'] === '0. Зарегистрировано' && ticket['Документ'] !== "ТОиППР" && !(ticket['ФизОбъект'].indexOf('25 октября') !== -1)) {
          this.t_r.list.push(ticket)
          this.t_r.status = true
        }
        if (ticket['СтатусПредставление'] === '1. В работе (в графике)' || ticket['Документ'] === "ТОиППР") {
          this.t_w.list.push(ticket)
          this.t_w.status = true
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
